import React from 'react'
import {change as changeFieldValue, Field, formValueSelector, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import $ from 'jquery';
import cadastrarConexao from '../../actions/rota/cadastrarConexao';
import selecionarConexao from '../../actions/rota/selecionarConexao';
import {renderField, renderFieldCheck, required} from '../../util/inputs';
import selecionarOrigem from '../../actions/origem/selecionarOrigem';
import selecionarDestino from '../../actions/destino/selecionarDestino';
import alterarExibicaoDetalhamentoRota from '../../actions/rota/alterarExibicaoDetalhamentoRota';
import SelecaoCidadeAutocompleteRotaConexao from './SelecaoCidadeAutocompleteRotaConexao';
import {showSuccessMsg} from '../../util/messagesUtil';
import buscarRotas from '../../actions/rota/buscarRotas';

export const renderFieldAutoCompleteCidadade = ({
  selecionarCidade,
  placeholder,
  valor,
  meta: { touched, error }
}) => (
  <div>
    <SelecaoCidadeAutocompleteRotaConexao placeholder={placeholder}
                               selecionarCidade={selecionarCidade}
                               value={valor}/>
    {touched
    && (error && <span style={{ color: 'red' }}>{error}</span>)}
  </div>
);

export class ModalCadastroConexao extends React.Component {
  constructor (props) {
    super(props);
    this.submit = this.submit.bind(this);

  }

  submit (values) {
    this.props.cadastrarConexao(this.montarParametroCriacaoConexao(values))
      .then(() => {
          showSuccessMsg('Rota atualizada com sucesso');
          this.props.buscarRotas(this.props.empresaSelecionada.id, this.props.paginaAtual, this.props.registrosPorPagina, this.props.filtrosAdicionados)
          .then(() => {
                this.props.alterarExibicaoDetalhamentoRota(this.props.rotaSelecionada);
                this.fecharModal();
              }
            );
      })
  }

  fecharModal () {
    $('#modalCadastroConexao').modal('hide');
    $('.modal-backdrop').remove();
    $('body').removeClass('modal-open');
    this.props.selecionarOrigem(null);
    this.props.selecionarDestino(null);
    this.props.selecionarConexao(null);
    this.props.reset('formularioCadastroConexao');
    // random para forçar limpeza do componente limpezaCidadeAutocomplete
    this.props.changeFieldValue('formularioCadastroConexao', 'cidadeOrigem', Math.random());
    this.props.changeFieldValue('formularioCadastroConexao', 'cidadeDestino', Math.random());
  }

  montarParametroCriacaoConexao (values) {
    return {
      id: this.props.conexaoSelecionada ? this.props.conexaoSelecionada.id : null,
      rotaId: this.props.rotaSelecionada.id,
      cidadeOrigemId: this.props.origem.id,
      cidadeDestinoId: this.props.destino.id,
      prefixo: values.prefixo,
      empresaId: this.props.empresaSelecionada.id,
      habilitadoTipoEscala: this.props.habilitadoTipoEscala
    };
  }

  render () {
    const {
      handleSubmit, invalid, submitting
    } = this.props;
    return (
      <div className="modal fade show" id="modalCadastroConexao" role="dialog"
           aria-labelledby="modalCadastroConexao" aria-hidden="true" data-backdrop="static">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content" style={{ borderRadius: 12, overflow: 'hidden', border: 'none' }}>
            <div className="vx-modal-header">
              <div className="vx-modal-title">
                <span className="material-icons">{this.props.conexaoSelecionada && this.props.conexaoSelecionada.id ? 'edit' : 'add'}</span>
                Nova Conexão
              </div>
              <button type="button" className="vx-modal-close" data-dismiss="modal" aria-label="Close"
                      onClick={() => this.fecharModal()}>
                <span className="material-icons">close</span>
              </button>
            </div>
            <div className="vx-modal-body" style={{ background: '#fff' }}>
              <form onSubmit={handleSubmit(this.submit)}>
                <div className="form-row">
                  <div className="col-12 col-sm-9 col-md-9">
                    {this.props.conexaoSelecionada && this.props.conexaoSelecionada.id && (
                      <div className="form-row">
                        <div className="col-12 col-sm-9 col-md-9">
                          <span style={{ fontWeight: 'bold' }}>ID: </span>{this.props.conexaoSelecionada.id}
                        </div>
                      </div>
                    )}
                    <div className="form-row">
                      <div className="col-12 col-sm-9 col-md-9">
                        <Field name="prefixo" type="text" component={renderField} label="Prefixo:"
                               css="form-control" readOnly={false} validate={[required]}/>
                      </div>
                    </div>
                    <div className="form-row mt-2">
                      <div className="col-12 col-sm-9 col-md-6">
                        <Field name='cidadeOrigem'
                               component={renderFieldAutoCompleteCidadade}
                               selecionarCidade={this.props.selecionarOrigem}
                               valor={this.props.cidadeOrigem}
                               placeholder='Cidade de Origem'/>
                      </div>
                      <div className="col-12 col-sm-9 col-md-6">
                        <Field name='cidadeDestino'
                               component={renderFieldAutoCompleteCidadade}
                               selecionarCidade={this.props.selecionarDestino}
                               valor={this.props.cidadeDestino}
                               placeholder='Cidade de Destino'/>
                      </div>
                      <div>
                        <Field name='habilitadoTipoEscala' type="checkbox" component={renderFieldCheck}
                                                  label="Tipo Escala"
                                                  css="form-check-input mt-2" readOnly={false} />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="vx-modal-footer mt-4">
                  <button type="submit" disabled={invalid || submitting || !this.props.origem || !this.props.destino}
                          className="vx-modal-btn-confirmar">
                    <span className="material-icons" style={{ fontSize: 15 }}>save</span>
                    Salvar
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export function mapStateToProps (state) {
  return {
    initialValues:{
      cidadeOrigem: state.conexaoSelecionada ? state.conexaoSelecionada.cidadeOrigem : null,
      cidadeDestino: state.conexaoSelecionada ? state.conexaoSelecionada.cidadeDestino : null,
      prefixo: state.conexaoSelecionada ? state.conexaoSelecionada.prefixo : null,
      habilitadoTipoEscala: state.conexaoSelecionada ? state.conexaoSelecionada.habilitadoTipoEscala : null
    },
    cidadeOrigem: formValueSelector('formularioCadastroConexao')(state, 'cidadeOrigem'),
    cidadeDestino: formValueSelector('formularioCadastroConexao')(state, 'cidadeDestino'),
    prefixo: formValueSelector('formularioCadastroConexao')(state, 'prefixo'),
    habilitadoTipoEscala: formValueSelector('formularioCadastroConexao')(state, 'habilitadoTipoEscala'),
    empresaSelecionada: state.empresaSelecionada,
    paginaAtual: state.paginaAtualRota,
    registrosPorPagina: state.registrosPorPaginaRota,
    filtrosAdicionados: state.filtrosAdicionadosRota,
    usuarioSelecionado: state.usuarioSelecionado,
    conexaoSelecionada: state.conexaoSelecionada,
    rotaSelecionada: state.rotaSelecionada,
    origem: state.origem,
    destino: state.destino
  }
}


export const mapDispatchToProps = dispatch => (
  bindActionCreators({
    changeFieldValue,
    cadastrarConexao,
    selecionarConexao,
    selecionarOrigem,
    selecionarDestino,
    alterarExibicaoDetalhamentoRota,
    buscarRotas
  }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
  form: 'formularioCadastroConexao',
  enableReinitialize: true,
  destroyOnUnmount: true,
  forceUnregisterOnUnmount: true
})(ModalCadastroConexao));
